<template lang="pug">
  div.normative
    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
    :hideDeleteButton="false"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs()
      slot
        e-form(:formValidator="formValidator")
          div.body
            div.col
              e-form-group(
              name="name"
              label="Наименование"
              :model="fields"
              tabView="tab1"
              :required="true"
              :disabled="disabledInEditMode"
              )

              e-form-group(
              name="calculation_unit_id"
              inputType="select"
              label="Расчетная единица"
              :model="fields"
              :options="calculationUnit"
              tabView="tab1"
              :required="true"
              :disabled="disabledInEditMode"
              )

              e-form-group(
              name="tariff_branch_id"
              inputType="select"
              label="Тариф"
              :model="fields"
              :options="unclosedTariff"
              tabView="tab1"
              :required="true"
              :disabled="disabledInEditMode"
              )

              e-form-group(
              name="garbage_source_category_id"
              inputType="select"
              label="Категория отходообразователя"
              :model="fields"
              :options="garbageCategory"
              tabView="tab1"
              :required="true"
              :disabled="disabledInEditMode"
              )

              e-form-group(
                name="normativ_characteristic_id"
                inputType="select"
                label="Автозаполнять новые КУ из поля"
                :model="fields"
                :options="normativCharacteristic"
                tabView="tab1"
                :required="!disabledInEditMode"
                :disabled="disabledInEditMode"
              )

            div.col
              e-form-group(
              name="fias_locality"
              inputType="select-nested-list"
              label="Зоны действия"
              :model="fields"
              :options="fias"
              tabView="tab1"
              optionTextKey="offname"
              optionValueKey="aoguid"
              optionParentKey="parentguid"
              :optionTextFunc="zoneOptionTextFunc"
              childsKey="childLocalities"
              :disabled="disabledInEditMode"
              )

          div.body.body-table
            branch-normatives(
            :id="itemId"
            :model="fields"
            )


</template>

<script>
  import normativeForm from './mixins/normative-form'
  import {billing, core} from "../../api/api-endpoints"
  import {GARBAGE_TYPE_INDIVIDUAL_AREA} from "../../config/config"
  import BranchNormatives from "./components/branch-normatives";

  export default {
    components: {BranchNormatives},
    mixins: [normativeForm],
    data () {
      return {
        fields: {
          garbage_source_type_id: GARBAGE_TYPE_INDIVIDUAL_AREA
        }
      }
    },
    methods: {
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return billing.normativeBranch(route.params.id)
      },
      getCollectionEndpoint () {
        return core.collection('calculation_unit,garbage_category,normativ_characteristic')
      },
      getUnclosedTariffEndpoint () {
        return billing.branchs({
          query: {
            'per-page': -1
          }
        })
      },
      getUpdateOrCreateUrl () {
        return billing.normativeCreateOrUpdate(this.$route.params.id)
      },
      getFiasEndpoint () {
        return core.fias()
      }
    }
  }
</script>
